<render-component [page]=page [pageComponents]=aboutContent.page_components></render-component>